import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    palette: {
      primary: { main: "#367C2B" },
      secondary: { main: "#FFDE00" },
    },
    typography: { useNextVariants: true, fontSize: "small"},
    
  });